import { render, staticRenderFns } from "./jd-file-upload.vue?vue&type=template&id=6042dc0c&scoped=true&"
import script from "./jd-file-upload.vue?vue&type=script&lang=js&"
export * from "./jd-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./jd-file-upload.vue?vue&type=style&index=0&id=6042dc0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6042dc0c",
  null
  
)

export default component.exports